import { isFeatureEnabled } from '~/core/utils/isFeatureEnabled';
import useMainStore from '~/stores/useMainStore';
export default defineNuxtPlugin(function () {
  var mainStore = useMainStore();
  return {
    provide: {
      featureFlag: function featureFlag(feature) {
        return isFeatureEnabled(feature, mainStore.featureFlags);
      }
    }
  };
});